<template>
  <div class="home_wrap">
    <Header></Header>
    <van-row class="topSection">
      <van-col span="6" style="text-align: left">
        <router-link to="/member">
          <img src="../images/common/backArrow.png" class="imageback"
        /></router-link>
      </van-col>
      <van-col span="18" style="text-align: right">
        <span style="color: #ffffff; font-size: 30px; font-weight: 700">{{
          $t("fundingDetail.fundingDetails")
        }}</span>
      </van-col>
    </van-row>
    <!-- --------------------- active item ---------------- -->
    <van-row style="padding: 10px">
      <van-row class="fundingBox">
        <!-- ------- headings -------- -->
        <van-row class="tableHeadingBg">
          <van-col span="6" style="text-align: left"
            ><span class="tableHeading">{{
              $t("fundingDetail.project")
            }}</span></van-col
          >
          <van-col span="6"
            ><span class="tableHeading">{{
              $t("fundingDetail.amount")
            }}</span></van-col
          >
          <van-col span="6"
            ><span class="tableHeading">{{
              $t("fundingDetail.balance")
            }}</span></van-col
          >
          <van-col span="6" style="text-align: right"
            ><span class="tableHeading">{{
              $t("fundingDetail.time")
            }}</span></van-col
          >
        </van-row>
        <!-- ---------- data row -------- -->

        <van-list
          v-model:loading="loading"
          :finished="finished"
          :finished-text="$t('bonus.loadFinish')"
          @load="onLoad"
          offset:20
        >
          <van-row
            class="tableDataBg"
            v-for="(item, index) in moneyLog"
            :key="index"
          >
            <van-col span="6" style="text-align: left"
              ><span class="tabledata">{{
                item.user_money_type[lang]
              }}</span></van-col
            >
            <van-col span="6"
              ><span v-bind:class="[item.mold == 1 ? 'red' : 'green']">{{
                (item.mold == 1 ? "- " : "+ ") + item.money
              }}</span></van-col
            >
            <van-col span="6"
              ><span class="tabledata">{{ item.after }}</span></van-col
            >
            <van-col span="6" style="text-align: right"
              ><span class="tabledata">{{
                getDate(item.createtime)
              }}</span></van-col
            >
          </van-row>
        </van-list>
      </van-row>
    </van-row>
  </div>
</template>

<script>
import Vue from "vue";
import Header from "../../components/header";
import { Icon, Col, Row, List } from "vant";
import Fetch from "../../utils/fetch";
import moment from "moment";
import loading from "../../store/loading";
import { finished } from "stream";
Vue.use(Icon).use(Row).use(Col).use(List);

export default {
  name: "fundingdetails",
  components: {
    Header,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      moneyLog: [],
      loading: false,
      finished: false,
      currentPage: 0,
    };
  },
  mounted() {
   
  },
  methods: {
    getMoneyLog() {
      let that = this;
      Fetch("/finance/money_log_list", {
        page: this.currentPage,
        num: 40,
      }).then((res) => {
        this.loading = false;

        if (res.data.length === 0) this.finished = true;

        this.moneyLog = this.moneyLog.concat(res.data);
      });
    },
    getDate(time) {
      return moment.unix(time).format("DD/MM/YYYY");
    },
    onLoad() {
      this.currentPage++;
      
      this.getMoneyLog();
    },
  },
};
</script>

<style lang="less" scoped>
.home_wrap {
  width: 100%;
  min-height: 100vh;
  background: url("../images/common/BgImg.png");
  background-size: 100% 100%;
}

.topSection {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 30px 15px 20px;
}

.imageback {
  height: 40px;
  width: auto;
}

.fundingBox {
  box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 20px 15px;
  background: #ebebeb29;
}

.tableHeadingBg {
  background: rgba(255, 255, 255, 0.25);
  border-radius: 3px;
  padding: 4px 10px;
  text-align: center;
  margin-bottom: 10px;
}

.tableHeading {
  color: #ffffff;
  font-size: 15px;
  text-align: center;
}

.tableDataBg {
  padding: 8px 10px;
  text-align: center;
}

.tabledata {
  color: #ffffff;
  font-size: 14px;
  text-align: center;
}

.green {
  font-size: 14px;
  color: #00ff47;
  white-space: nowrap;
}

.red {
  font-size: 14px;
  color: #e75454;
  white-space: nowrap;
}
</style>
